import { QuestionType } from '@empathy/survey/base';
import { Question } from '@empathy/survey-core';

import { QuestionForm } from './question-form.model';

export class QuestionFormTerminate extends QuestionForm {
  constructor() {
    super();
  }

  initEmpty(nextId: number, pageId: string): void {
    super.initEmpty(nextId, pageId);
    this.form.get('type').setValue(QuestionType.Terminate);
    this.form.get('title').setValue(`Terminate ${nextId}`);
  }

  init(question: Question): void {
    super.init(question);
  }
}
